export const USER_ID_KEY = 'USER_ID';

export const PAYMENTS_METHODS = ['EURO', 'USD'];
